import { Typography } from '@material-ui/core';
import { Box,
    DialogTitle as MuiDialogTitle, IconButton,
    TextField as MuiTextField } from '@mui/material';
import { styled } from '@mui/system';

import { colors } from '../../theme';

export const dialogPaperProps = {
    style: {
        backgroundColor: colors.darkBlue,
        color: colors.white,
        padding: '20px',
        borderRadius: '8px',
        margin: '16px',
        maxWidth: '600px'
    }
};

export const DialogTitle = styled(MuiDialogTitle)({
    textAlign: 'center',
    fontWeight: 'bold'
});

export const DialogTextField = styled(MuiTextField)({
    '& .MuiOutlinedInput-root': {
        backgroundColor: colors.darkBlue,
        borderRadius: '8px',
        color: colors.white,
        fontSize: '14px',
        '& fieldset': {
            borderColor: colors.darkGray
        },
        '&:hover fieldset': {
            borderColor: colors.hitGray
        },
        '&.Mui-focused fieldset': {
            borderColor: colors.lightningYellow
        }
    },
    '& .MuiInputBase-input': {
        color: colors.white,
        fontSize: '14px'
    },
    '& .MuiInputBase-input::placeholder': {
        color: colors.lightGray,
        opacity: 0.8
    }
});

export const DialogContent = styled(Box)({
    paddingTop: '20px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px'
});

export const DialogButtonContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginTop: '20px',
    width: '100%',
    maxWidth: '500px',
    marginLeft: 'auto',
    marginRight: 'auto'
});

export const AttachmentUploadWrapper = styled(Box)({
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
    '& > div': {
        width: '100% !important',
        maxWidth: '100% !important',
        boxSizing: 'border-box',
        paddingLeft: '0px !important'
    },
    '& label': {
        maxWidth: '100% !important',
        width: '100% !important',
        paddingLeft: '0px !important'
    },
    '& *': {
        maxWidth: '100%',
        boxSizing: 'border-box'
    }
});

export const DialogCloseButton = styled(IconButton)({
    position: 'absolute',
    right: '8px',
    top: '8px',
    color: colors.white,
    '&:hover': {
        backgroundColor: colors.darkGray
    }
});

export const DialogDescription = styled(Typography)({
    color: colors.white,
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: '10px',
    textAlign: 'center',
    width: '100%',
    maxWidth: '500px'
});

